import { mapProductKeyToLegacyProductKey } from 'data/products/keys';
import { State } from 'model/State';
import { getSoftwareProduct } from 'data/products';
import selectValidParents from 'modules/addon/duck/selectors/validParents';

export default (state: State) =>
  selectValidParents(state)
    .map(([parent]) => (parent ? mapProductKeyToLegacyProductKey(parent) : null))
    .map((parent) => parent && getSoftwareProduct(parent));
